import { MessageService } from 'primeng/api';

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { ProgressService } from 'src/app/services/progress.service';
import { Observable } from 'rxjs';
import { Race } from 'src/app/models/race';
import { RaceClass } from 'src/app/models/race-class';
import { Score, Equal_Score } from 'src/app/models';

@Component({
  selector: 'app-overval',
  templateUrl: './overval.component.html',
  styleUrls: ['./overval.component.scss'],
})
export class OvervalComponent implements OnInit {
  @Input() visibleDialog!: boolean;
  @Input() selectedRace!: Race;
  @Input() selectedClass!: RaceClass;
  @Output() closeEvent = new EventEmitter();
  @Output() printOvervalEvent = new EventEmitter();
  day_1!: number;
  month_1!: number;
  year_1!: number;
  selectedRace_1!: Race;

  day_2!: number;
  month_2!: number;
  year_2!: number;
  selectedRace_2!: Race;

  day_3!: number;
  month_3!: number;
  year_3!: number;
  selectedRace_3!: Race;

  day_4!: number;
  month_4!: number;
  year_4!: number;
  selectedRace_4!: Race;

  day_5!: number;
  month_5!: number;
  year_5!: number;
  selectedRace_5!: Race;

  day_6!: number;
  month_6!: number;
  year_6!: number;
  selectedRace_6!: Race;

  score$: Observable<Score[]> | undefined;
  scores_equal$: Observable<Equal_Score[]> | undefined;

  userform!: FormGroup;

  not_found: boolean = false;
  not_found_3: boolean = false;
  not_found_4: boolean = false;
  not_found_5: boolean = false;
  not_found_6: boolean = false;
  loading: boolean;
  dates: Race[][][][] = [];
  raceDataOverval_1!: Race;
  raceDataOverval_2!: Race;
  raceDataOverval_3!: Race;
  raceDataOverval_4!: Race;
  raceDataOverval_5!: Race;
  raceDataOverval_6!: Race;

  constructor(public progressService: ProgressService, private fb: FormBuilder, private messageService: MessageService) {
    this.loading = false;
    this.score$ = this.progressService.getScore();
    this.scores_equal$ = this.progressService.getEqualScores();
  }

  async ngOnInit() {
    await this.changeMonth({ month: this.selectedRace.date.getMonth(), year: this.selectedRace.date.getFullYear() });
    this.update();
  }

  update() {
    this.userform = this.fb.group({
      date_1: new FormControl(this.selectedRace.date, Validators.required),
      date_2: new FormControl(this.selectedRace.date, Validators.required),
      date_3: new FormControl(this.selectedRace.date, Validators.required),
      date_4: new FormControl(this.selectedRace.date, Validators.required),
      date_5: new FormControl(this.selectedRace.date, Validators.required),
      date_6: new FormControl(this.selectedRace.date, Validators.required),
      selectedRace_1: new FormControl(null, Validators.required),
      selectedRace_2: new FormControl(this.selectedRace, Validators.required),
      selectedRace_3: new FormControl(null),
      selectedRace_4: new FormControl(null),
      selectedRace_5: new FormControl(null),
      selectedRace_6: new FormControl(null),
      score: new FormControl(null, Validators.required),
      scores_equal: new FormControl(null, Validators.required),
    });
    this.selectDay(this.userform.get('date_1')?.value, '1');
    this.selectDay(this.userform.get('date_2')?.value, '2');
    this.selectDay(this.userform.get('date_3')?.value, '3', false);
    this.selectDay(this.userform.get('date_4')?.value, '4', false);
    this.selectDay(this.userform.get('date_5')?.value, '5', false);
    this.selectDay(this.userform.get('date_6')?.value, '6', false);
    // this.userform.get('selectedRace_2').setValue(this.selectedRace);
    this.userform.get('score')?.markAsDirty();
    this.userform.get('scores_equal')?.markAsDirty();
  }

  onSubmit(csv: boolean = false) {
    if (!this.userform.invalid) {
      this.nextOvervalResult(csv);
    } else {
      this.userform.updateValueAndValidity();
    }
  }

  selectDay(date, type: '1' | '2' | '3' | '4' | '5' | '6', setValue = true) {
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();
    let selectedRaceTmp: Race | null | undefined = null;
    if (this.dates[year] && this.dates[year][month] && this.dates[year][month][day]) {
      selectedRaceTmp = this.dates[year][month][day][0];
    }

    if (!selectedRaceTmp) {
      return;
    }

    if (type === '1') {
      this.day_1 = day;
      this.month_1 = month;
      this.year_1 = year;
      if (setValue) {
        this.selectedRace_1 = selectedRaceTmp;
        this.userform.get('selectedRace_1')?.setValue(selectedRaceTmp);
      }
      this.loading = true;
      this.checkClass();
    } 
    else if (type === '2') {
      this.day_2 = day;
      this.month_2 = month;
      this.year_2 = year;
      if (setValue) {
        selectedRaceTmp = this.dates[year][month][day].find(race => race.rUid === this.selectedRace.rUid);
        if (!selectedRaceTmp) {
          return;
        }
        this.selectedRace_2 = selectedRaceTmp;
        this.userform.get('selectedRace_2')?.setValue(selectedRaceTmp);
      }
    } 
    else if (type === '3') {
      this.day_3 = day;
      this.month_3 = month;
      this.year_3 = year;
      this.selectedRace_3 = selectedRaceTmp;
      if (setValue) {
        this.userform.get('selectedRace_3')?.setValue(selectedRaceTmp);
      }
      this.loading = true;
      this.checkClass();
    }
    else if (type === '4') {
      this.day_4 = day;
      this.month_4 = month;
      this.year_4 = year;
      this.selectedRace_4 = selectedRaceTmp;
      if (setValue) {
        this.userform.get('selectedRace_4')?.setValue(selectedRaceTmp);
      }
      this.loading = true;
      this.checkClass();
    } else if (type === '5') {
      this.day_5 = day;
      this.month_5 = month;
      this.year_5 = year;
      this.selectedRace_5 = selectedRaceTmp;
      if (setValue) {
        this.userform.get('selectedRace_5')?.setValue(selectedRaceTmp);
      }
      this.loading = true;
      this.checkClass();
    }
    else if (type === '6') {
      this.day_6 = day;
      this.month_6 = month;
      this.year_6 = year;
      this.selectedRace_6 = selectedRaceTmp;
      if (setValue) {
        this.userform.get('selectedRace_6')?.setValue(selectedRaceTmp);
      }
      this.loading = true;
      this.checkClass();
    }
  }

  async checkClass() {
    this.loading = false;
    const selectedRace_1 = this.userform.get('selectedRace_1')?.value;
    const selectedRace_3 = this.userform.get('selectedRace_3')?.value;
    const selectedRace_4 = this.userform.get('selectedRace_4')?.value;
    const selectedRace_5 = this.userform.get('selectedRace_5')?.value;
    const selectedRace_6 = this.userform.get('selectedRace_6')?.value;

    this.progressService.getRaceClasses(selectedRace_1).then((classes) => {
      if (
        classes && 
        classes.find((classObj) => {
          return classObj.name === this.selectedClass.name;
        })
      ) {
        this.not_found = false;
        this.userform.get('selectedRace_1')?.setErrors({ incorrect: false });
        this.userform.get('selectedRace_1')?.updateValueAndValidity();
      } else {
        this.not_found = true;
        this.userform.get('selectedRace_1')?.setErrors({ incorrect: true });
        this.userform.get('selectedRace_1')?.markAsDirty();
      }
    });

    if (selectedRace_3) {
      this.progressService.getRaceClasses(selectedRace_3).then((classes) => {
        if (
          classes &&
          classes.find((classObj) => {
            return classObj.name === this.selectedClass.name;
          })
        ) {
          this.not_found_3 = false;
          this.userform.get('selectedRace_3')?.setErrors({ incorrect: false });
          this.userform.get('selectedRace_3')?.updateValueAndValidity();
        } else {
          this.not_found_3 = true;
          this.userform.get('selectedRace_3')?.setErrors({ incorrect: true });
          this.userform.get('selectedRace_3')?.markAsDirty();
        }
      });
    }

    if (selectedRace_4) {
      this.progressService.getRaceClasses(selectedRace_4).then((classes) => {
        if (
          classes &&
          classes.find((classObj) => {
            return classObj.name === this.selectedClass.name;
          })
        ) {
          this.not_found_4 = false;
          this.userform.get('selectedRace_4')?.setErrors({ incorrect: false });
          this.userform.get('selectedRace_4')?.updateValueAndValidity();
        } else {
          this.not_found_4 = true;
          this.userform.get('selectedRace_4')?.setErrors({ incorrect: true });
          this.userform.get('selectedRace_4')?.markAsDirty();
        }
      });
    }

    if (selectedRace_5) {
      this.progressService.getRaceClasses(selectedRace_5).then((classes) => {
        if (
          classes &&
          classes.find((classObj) => {
            return classObj.name === this.selectedClass.name;
          })
        ) {
          this.not_found_5 = false;
          this.userform.get('selectedRace_5')?.setErrors({ incorrect: false });
          this.userform.get('selectedRace_5')?.updateValueAndValidity();
        } else {
          this.not_found_5 = true;
          this.userform.get('selectedRace_5')?.setErrors({ incorrect: true });
          this.userform.get('selectedRace_5')?.markAsDirty();
        }
      });
    }

    if (selectedRace_6) {
      this.progressService.getRaceClasses(selectedRace_6).then((classes) => {
        if (
          classes &&
          classes.find((classObj) => {
            return classObj.name === this.selectedClass.name;
          })
        ) {
          this.not_found_6 = false;
          this.userform.get('selectedRace_6')?.setErrors({ incorrect: false });
          this.userform.get('selectedRace_6')?.updateValueAndValidity();
        } else {
          this.not_found_6 = true;
          this.userform.get('selectedRace_6')?.setErrors({ incorrect: true });
          this.userform.get('selectedRace_6')?.markAsDirty();
        }
      });
    }
  }

  nextOvervalResult(csv: boolean = false) {
    this.printOvervalEvent.emit({
      selectedRace_1: this.userform.get('selectedRace_1')?.value,
      selectedRace_2: this.userform.get('selectedRace_2')?.value,
      selectedRace_3: this.userform.get('selectedRace_3')?.value,
      selectedRace_4: this.userform.get('selectedRace_4')?.value,
      selectedRace_5: this.userform.get('selectedRace_5')?.value,
      selectedRace_6: this.userform.get('selectedRace_6')?.value,
      score: this.userform.get('score')?.value,
      scores_equal: this.userform.get('scores_equal')?.value,
      csv
    });
  }

  showMessage(el: any) {
    this.messageService.add({ severity: 'error', summary: el.target.title });
  }

  async changeMonth(event) {
    const date = new Date();
    date.setMonth(event.month - 1);
    date.setFullYear(event.year);
    const ret = await this.progressService.getRaces(date, this.dates);
    if (ret) {
      this.dates = ret;
    } else {
      console.log('Нет данных');
    }
  }
}
